export default __webpack_public_path__ + "file/Fiche-FR-Produit-Puroak-Block-7.asset.78145522.pdf";